import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, SwitchCheckbox, ToggleButton, ToggleButtonGroup, Tooltip, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const MonitorHeader = (props) => {
  const {
    summaryText,
    ranges,
    rangeKey,
    onRangeKeyChange,
    loadMarked,
    onLoadMarkedChange,
    loadCompleted,
    loadCompletedDisabled,
    onLoadCompletedChange,
  } = props;

  return (
    <Stack
      direction={{xs: 'column', lg: 'row'}}
      justifyContent='space-between'
      alignItems={{xs: 'flex-start', lg: 'center'}}
      spacing={2}
      sx={{px: 3, py: 2}}
    >
      <Stack direction='row' spacing={1.5} alignItems='baseline' flexWrap='wrap' useFlexGap>
        <Typography sx={{fontSize: '20px', fontWeight: 600, color: '#1A1916'}}>
          <Translate expression='case.Monitor.Title' />
        </Typography>
        <Typography sx={{fontSize: '13px', color: '#A8A49E'}}>
          {summaryText}
        </Typography>
      </Stack>
      <Stack direction='row' spacing={2} alignItems='center' flexWrap='wrap' useFlexGap>
        <ToggleButtonGroup
          exclusive
          size='small'
          value={rangeKey}
          onChange={(event, nextRangeKey) => nextRangeKey && onRangeKeyChange(nextRangeKey)}
          sx={{
            'backgroundColor': '#FFFFFF',
            '& .MuiToggleButton-root': {
              'px': 1.5,
              'py': 0.5,
              'fontSize': '12px',
              'textTransform': 'none',
              'color': '#4B4B55',
              'borderColor': '#ECECF1',
              '&.Mui-selected': {
                color: '#C4512C',
                fontWeight: 600,
                backgroundColor: '#FFF1EC',
              },
            },
          }}
        >
          {
            ranges.map((range) => (
              <ToggleButton key={range.key} value={range.key}>
                <Translate expression={`case.Monitor.Range.${range.key}`} />
              </ToggleButton>
            ))
          }
        </ToggleButtonGroup>
        <Stack direction='row' alignItems='center'>
          <SwitchCheckbox
            size='small'
            value={loadMarked}
            onChange={onLoadMarkedChange}
            inputProps={{'aria-label': translate('case.Monitor.LoadMarked')}}
          />
          <Box component='span' sx={{fontSize: '13px', color: '#1A1916'}}>
            <Translate expression='case.Monitor.LoadMarked' />
          </Box>
        </Stack>
        <Tooltip title={loadCompletedDisabled ? translate('case.Monitor.LoadCompletedAllTime') : ''}>
          <Stack direction='row' alignItems='center'>
            <SwitchCheckbox
              disabled={loadCompletedDisabled}
              size='small'
              value={loadCompleted && !loadCompletedDisabled}
              onChange={onLoadCompletedChange}
            />
            <Box component='span' sx={{fontSize: '13px', color: loadCompletedDisabled ? '#A8A49E' : '#1A1916'}}>
              <Translate expression='case.Monitor.LoadCompleted' />
            </Box>
          </Stack>
        </Tooltip>
      </Stack>
    </Stack>
  );
};

MonitorHeader.propTypes = {
  summaryText: PropTypes.string.isRequired,
  ranges: PropTypes.array.isRequired,
  rangeKey: PropTypes.string.isRequired,
  onRangeKeyChange: PropTypes.func.isRequired,
  loadMarked: PropTypes.bool.isRequired,
  onLoadMarkedChange: PropTypes.func.isRequired,
  loadCompleted: PropTypes.bool.isRequired,
  loadCompletedDisabled: PropTypes.bool.isRequired,
  onLoadCompletedChange: PropTypes.func.isRequired,
};

export default React.memo(MonitorHeader);
